// extracted by mini-css-extract-plugin
export var active = "_a0-c";
export var activeIndicator = "_a0-7";
export var animate = "_a0-b";
export var contentWidthTabs = "_a0-5";
export var disabled = "_a0-d";
export var flat = "_a0-1";
export var fullWidth = "_a0-3";
export var lg = "_a0-a";
export var md = "_a0-9";
export var redoButtonTabGroup = "_a0-0";
export var sm = "_a0-8";
export var tabButton = "_a0-4";
export var tabButtonsContainer = "_a0-2";
export var xs = "_a0-6";